import React from "react";
import { Button, Icon } from "react-onsenui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera, faPlus, faSync } from "@fortawesome/free-solid-svg-icons";

const Stage5Content = ({ claim, setUploadType, setDocName, setCameraModalVis, handleDocPreview, setPreviewDocModal, setFocusedExtraImageID }) => {
  return (
    <>
      {/* Header Section */}
      <div style={{ padding: "20px", backgroundColor: "#5C7232", color: "#fff" }}>
        <h2 style={{ fontSize: "26px", fontWeight: "600" }}>सामुदायिक अधिकारों की अनुशंसा के लिए ग्राम सभा</h2>
      </div>

      {/* Form 12 Section */}
      <div style={{ borderTop: "1px solid #fff", padding: "20px" }}>
        <h4 style={{ fontSize: "18px", fontWeight: "600" }}>ग्राम सभा की कार्यवाही (2.10) (संलग्न 9)</h4>

        <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0" }}>
          <Button
            modifier="large"
            style={{ width: "40%", marginLeft: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
            onClick={() => {
              if (!Boolean(claim?.courtDocuments[11]?.title === "SDM_SUMMON_RESULT_12")) {
                setUploadType("MAIN_DOC");
                setDocName("SDM_SUMMON_RESULT_12");
                setCameraModalVis(true);
              } else {
                setPreviewDocModal(true);
                handleDocPreview(claim?.courtDocuments[11]?.storageUrl);
              }
            }}
          >
            {!Boolean(claim?.courtDocuments[11]?.title === "SDM_SUMMON_RESULT_12") ? (
              <>
                <Icon icon="md-camera" size={20} />
                {Boolean(
                  claim?.extraImageFormCountForSync &&
                    claim?.extraImageFormCountForSync["SDM_SUMMON_RESULT_12"] !== 0
                ) && (
                  <FontAwesomeIcon icon={faSync} size="lg" color="#fff" style={{ marginLeft: "10px" }} />
                )}
              </>
            ) : (
              "फोटो देखें"
            )}
          </Button>

          {Boolean(claim?.courtDocuments[11]?.title === "SDM_SUMMON_RESULT_12") && (
            <Button
              modifier="large"
              style={{ width: "40%", marginRight: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
              onClick={() => {
                setDocName("SDM_SUMMON_RESULT_12");
                setUploadType("MAIN_DOC");
                setCameraModalVis(true);
              }}
            >
              <FontAwesomeIcon icon={faCamera} size="lg" />
            </Button>
          )}
        </div>

        {claim?.courtDocuments[11]?.extraImages?.map((item, indd) => (
          <div key={`extra-image-${indd}`} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0" }}>
            <Button
              modifier="large"
              style={{ width: "40%", marginLeft: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
              onClick={() => {
                if (!(claim?.courtDocuments.length && claim?.courtDocuments[11]?.title === "SDM_SUMMON_RESULT_12")) {
                  setDocName("SDM_SUMMON_RESULT_12");
                  setCameraModalVis(true);
                } else {
                  setPreviewDocModal(true);
                  handleDocPreview(item?.url);
                }
              }}
            >
              {!Boolean(claim?.courtDocuments[11]?.title === "SDM_SUMMON_RESULT_12") ? (
                <FontAwesomeIcon icon={faCamera} size="lg" />
              ) : (
                "फोटो देखें"
              )}
            </Button>

            {claim?.courtDocuments[11]?.title === "SDM_SUMMON_RESULT_12" && (
              <Button
                modifier="large"
                style={{ width: "40%", marginRight: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
                onClick={() => {
                  setDocName("SDM_SUMMON_RESULT_12");
                  setCameraModalVis(true);
                  setFocusedExtraImageID(indd + 1);
                  setUploadType("UPDATE_EXTRA_IMAGE");
                }}
              >
                <FontAwesomeIcon icon={faCamera} size="lg" />
              </Button>
            )}
          </div>
        ))}

        <div style={{ display: "flex", justifyContent: "center", padding: "20px 0" }}>
          {Boolean(
            claim?.courtDocuments[11]?.title === "SDM_SUMMON_RESULT_12" ||
              Boolean(
                claim?.extraImageFormCountForSync &&
                  claim?.extraImageFormCountForSync["SDM_SUMMON_RESULT_12"] !== 0
              )
          ) && (
            <Button
              modifier="large"
              style={{ width: "40%", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
              onClick={() => {
                setDocName("SDM_SUMMON_RESULT_12");
                setCameraModalVis(true);
                setUploadType("NEW_EXTRA_IMAGE");
              }}
            >
              <FontAwesomeIcon icon={faPlus} size="lg" />
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

export default Stage5Content;